/* @flow */

import { StorageKeys } from '../localStorage/keys';
import LocalStorageManager from '../localStorage/localStorageManager';
import ProfilesManager from '../profiles/profilesManager';
import { SEARCH } from './constants';

const deleteSearchHistory: (profileId?: string) => Array<string> = (profileId) => {
  LocalStorageManager.delete(ProfilesManager.buildProfileKey(StorageKeys.SearchHistory, profileId));
  return [];
};

const getSearchHistory: () => Array<string> = () => LocalStorageManager.loadObject(ProfilesManager.buildCurrentProfileKey(StorageKeys.SearchHistory), []);

const deleteTermInternal: (term: string) => Array<string> = (term) => {
  const history = LocalStorageManager.loadObject(ProfilesManager.buildCurrentProfileKey(StorageKeys.SearchHistory), []);

  if (!Array.isArray(history) || history.length === 0) {
    return [];
  }

  const trimmedTerm = term.trim();
  const pos = history.indexOf(trimmedTerm);
  if (pos > -1) {
    history.splice(pos, 1);
  }

  return history;
};

const deleteSearchString: (term: string) => Array<string> = (term) => {
  const history = deleteTermInternal(term);
  LocalStorageManager.save(ProfilesManager.buildCurrentProfileKey(StorageKeys.SearchHistory), history);
  return history;
};

const saveSearchString: (term?: string) => Array<string> = (term) => {
  if (!term) {
    return getSearchHistory();
  }

  const history = deleteTermInternal(term);

  const trimmedTerm = term.trim();
  if (trimmedTerm === '') {
    return history;
  }

  history.unshift(trimmedTerm);

  if (history.length > SEARCH.HistoryMaxCount) {
    history.length = SEARCH.HistoryMaxCount;
  }

  LocalStorageManager.save(ProfilesManager.buildCurrentProfileKey(StorageKeys.SearchHistory), history);

  return history;
};

export { deleteSearchHistory, deleteSearchString, getSearchHistory, saveSearchString };
